module.exports = __webpack_public_path__ + "static/brucePage1-c85aa3be3d5bcb4ed05678c00b72aeb1.png";